module.exports = __webpack_public_path__ + "img/partying_face.17a6c0e4.gif";